// import {
//     LATEST_VERSION as latest_version_lt,
//     questions as questions_lt,
//     transform as transform_lt,
//     retransform as retransform_lt,
// } from "./lt/index";
import {
    LATEST_VERSION as latest_version_us,
    questions as questions_us,
    transform as transform_us,
    retransform as retransform_us,
} from "./us/index";

export function transform(model, locale = "us", version) {
    switch (locale) {
        // case "lt":
        //     return transform_lt(model, version);
        case "us":
        default:
            return transform_us(model, version);
    }
}

export function retransform(params, locale = "us", version) {
    switch (locale) {
        // case "lt":
        //     return retransform_lt(params, version);
        case "us":
        default:
            return retransform_us(params, version);
    }
}

export function questionByLocale(locale = "us", version) {
    switch (locale) {
        // case "lt":
        //     return questions_lt(version);
        case "us":
        default:
            return questions_us(version);
    }
}

export function latestVersionByLocale(locale = "us") {
    switch (locale) {
        // case "lt":
        //     return latest_version_lt;
        case "us":
        default:
            return latest_version_us;
    }
}
